export const app = () => {
  return {
    namespaced: true,
    state: {
      apiSessionInitialised: false,
    },
    mutations: {
      SET_API_INITALIZED (state) {
        state.apiInitialised = true
      }
    },
    actions: {
      async initialize ({commit}) {
        commit('SET_API_INITALIZED')
      }
    }
  }
}
